module.exports = __webpack_public_path__ + "img/22.7b6abe86.jpg";